import axios from '@/libs/api.request'
// 获取活动列表
export const getNewSpecialList = (params) => {
    return axios.request({
        url: 'newProducts',
        method: 'get',
        params: params
    })
}

// 获取活动详情
export const getNewSpecialDetails = (params) => {
    return axios.request({
        url: `newProducts/${params.id}`,
        method: 'get'
    })
}

export const action = (params) => {
    return axios.request({
        url: '/log/create',
        method: 'post',
        data: params
    })
}
